export function initFaqAccordion() {
    const accordions = document.querySelectorAll('[data-koch-faq]');
    if (!accordions.length) {
        return;
    }

    accordions.forEach((accordion) => {
        const items = accordion.querySelectorAll('.koch-faq__item');
        items.forEach((item) => {
            const button = item.querySelector('.koch-faq__question');
            const panel = item.querySelector('.koch-faq__answer');
            if (!button || !panel) {
                return;
            }

            button.addEventListener('click', () => {
                const isOpen = item.classList.contains('is-open');

                items.forEach((other) => {
                    if (other === item) {
                        return;
                    }
                    other.classList.remove('is-open');
                    const otherButton = other.querySelector('.koch-faq__question');
                    const otherPanel = other.querySelector('.koch-faq__answer');
                    if (otherButton) {
                        otherButton.setAttribute('aria-expanded', 'false');
                    }
                    if (otherPanel) {
                        otherPanel.hidden = true;
                    }
                });

                item.classList.toggle('is-open', !isOpen);
                button.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
                panel.hidden = isOpen;
            });
        });
    });

    document.querySelectorAll('[data-koch-faq-toggle]').forEach((toggle) => {
        toggle.addEventListener('click', () => {
            const section = toggle.closest('.koch-faq');
            if (!section) {
                return;
            }

            section.classList.add('is-expanded');
            section.querySelectorAll('.koch-faq__item--hidden').forEach((item) => {
                item.classList.remove('koch-faq__item--hidden');
            });
        });
    });
}
